module.exports = __webpack_public_path__ + "img/chlogo.d6f71178.png";